'use strict';

class Notifications {
  constructor($sce, notificationService) {
    this.$sce = $sce;
    this.notificationService = notificationService;
  }

  $onInit() {
    this.items = [];

    this.load();
  }

  load() {
    this.items = [];

    this.notificationService.getMessages()
      .then((resp) => {
        if (resp) {
          resp.map((m) => {
            m.styling = m.styling.toLowerCase();
            m.name = this.$sce.trustAsHtml(m.name);
            m.message = this.$sce.trustAsHtml(m.message);

            this.items.push(m);
          }, this);
        }
      });
  }

  // Set the notification read if the visibility is ONCE onload
  markAsReadOnce(item) {
    if (item.visibility === 'ONCE') {
      this.notificationService.markAsRead(item.id);
    }
  }

  // Mark notification. UNTIL_CLOSED, ONCE, ALWAYS
  mark(item) {
    if (item.visibility === 'UNTIL_CLOSED') {
      this.notificationService.markAsRead(item.id)
        .then(() => this.load());
    } else if (item.visibility === 'ONCE') {
      this.load();
    }
  }
}

Notifications.$inject = ['$sce', 'notificationService'];

const notifications = {
  bindings: {
    items: '<'
  },
  controller: Notifications,
  template: `
    <div id="notifcation_{{ item.id }}" data-id="{{ item.id }}" ng-init="$ctrl.markAsReadOnce(item)" class="alert-box {{ item.styling }}" ng-repeat="item in $ctrl.items">
      <div ng-bind-html="item.message"></div>
      <a href ng-if="item.visibility !== 'ALWAYS'" ng-click="$ctrl.mark(item)" class="close">&times;</a>
    </div>
  `
};

angular
  .module('sr.notification', [])
  .component('notifications', notifications);
